import {Component, Input, OnInit} from '@angular/core';
import {ErrorMessage} from '../../../../shared/models/error-message/ErrorMessage';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {

  @Input() errorMessages: ErrorMessage[];
  @Input() position: string;
  @Input() fieldName: string;
  @Input() isValid: boolean;
  localErrorMessages: ErrorMessage[];
  regex = /param/gi;

  constructor() {
  }

  ngOnInit(): void {
    this.localErrorMessages = this.errorMessages;
  }
}
